module.exports = __webpack_public_path__ + "img/logo.e99a692d.png";